import { useState } from "react";
import { useClient } from "./ClientProvider";
import api from "../services/api";
import { notifyError, notifySucces } from "../utils/notifications";
import {
  INSURANCE_CANCEL_PUSH_DESCRIPTION,
  INSURANCE_CANCEL_PUSH_JOURNEY,
  INSURANCE_CANCEL_PUSH_SUCCESS,
  INSURANCE_CANCEL_PUSH_TITLE,
} from "../helpers/getInsuranceCancelActionVisibility";

export function useSendInsuranceCancelPush() {
  const { client, refreshClientV2 } = useClient();
  const [sendingInsuranceCancelPush, setSendingInsuranceCancelPush] =
    useState(false);

  const sendInsuranceCancelPush = async () => {
    const cpf = client?.client?.cpf;
    if (!cpf) {
      notifyError("CPF do portador não encontrado");
      return false;
    }

    try {
      setSendingInsuranceCancelPush(true);
      const response = await api.post("push-api/notificacoes", {
        jornada: INSURANCE_CANCEL_PUSH_JOURNEY,
        cpf,
        client_id: client?.client?.id,
        titulo: INSURANCE_CANCEL_PUSH_TITLE,
        descricao: INSURANCE_CANCEL_PUSH_DESCRIPTION,
      });

      const statusCode = Number(response?.statusCode);
      if (Number.isFinite(statusCode) && statusCode !== 200) {
        notifyError(
          response?.detail ||
            response?.message ||
            "Falha ao enviar link de cancelamento de seguro"
        );
        return false;
      }

      notifySucces(INSURANCE_CANCEL_PUSH_SUCCESS);
      if (refreshClientV2) await refreshClientV2();
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : undefined;
      notifyError(message || "Falha ao enviar link de cancelamento de seguro");
      return false;
    } finally {
      setSendingInsuranceCancelPush(false);
    }
  };

  return { sendInsuranceCancelPush, sendingInsuranceCancelPush };
}
